(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3017],{

/***/ 60547:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/web/logistics-services",
      function () {
        return __webpack_require__(35430);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 35430:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ LogisticsServicesPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _components_service_pages_logistics_services_LogisticsServices__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19658);
/* harmony import */ var _components_service_pages_constants_logistics_services_methods__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28666);




var __N_SSG = true;
function LogisticsServicesPage(param) {
    var faqs = param.faqs;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_service_pages_logistics_services_LogisticsServices__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        faqs: faqs
    });
};
LogisticsServicesPage.getLayout = _components_service_pages_constants_logistics_services_methods__WEBPACK_IMPORTED_MODULE_3__/* .getLogisticsServicesPageLayout */ .h;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4304,6090,7783,5689,8935,9774,2888,179], function() { return __webpack_exec__(60547); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);